import { h } from 'preact';
import { GiftMessage } from '../../gift-message';
import { findBoxCapacity } from '../../../utils/box-capacity';
import { useCart } from './use-cart';
import { buildSelectableUnits } from './selectable-units';
import { computeCapacity } from './capacity';
import { CapacityBar } from './capacity-bar';
import { SelectItemRow } from './select-item-row';
import { t } from '../../../../theme/locales';
const StepSelectItems = ({ state , setState , giftboxProducts =null  })=>{
    const { cart , loading  } = useCart();
    const boxCapacity = findBoxCapacity(giftboxProducts, state.giftbox, state.variant);
    const selectableUnits = buildSelectableUnits((cart === null || cart === void 0 ? void 0 : cart.items) || []);
    const selectedItems = Array.isArray(state.items) ? state.items : state.items ? [
        state.items
    ] : [];
    const { remainingCapacity , usedPct , remainingCapacityPresentation  } = computeCapacity(selectedItems, selectableUnits, boxCapacity);
    const toggleItem = (unitKey)=>{
        const unit = selectableUnits.find((u)=>u.unitKey === unitKey);
        if (!unit) return;
        if (selectedItems.includes(unitKey)) {
            setState({
                items: selectedItems.filter((k)=>k !== unitKey)
            });
            return;
        }
        if (typeof remainingCapacity === 'number' && unit.effectiveSpace > remainingCapacity) return;
        setState({
            items: [
                ...selectedItems,
                unitKey
            ]
        });
    };
    return h('div', {
        className: 'gift-wrapping__step'
    }, [
        h('p', {
            className: 'gift-wrapping__step__description'
        }, t('gift_wrapping.steps.select_items.description')),
        boxCapacity != null ? h(CapacityBar, {
            usedPct,
            remainingCapacityPresentation
        }) : null,
        h('div', {
            className: 'select-items'
        }, [
            loading && h('p', {}, t('gift_wrapping.steps.loading')),
            !loading && selectableUnits.length === 0 && h('p', {}, t('gift_wrapping.steps.select_items.no_items')),
            !loading && selectableUnits.map((unit)=>{
                const checked = selectedItems.includes(unit.unitKey);
                const disabled = !checked && typeof remainingCapacity === 'number' && unit.effectiveSpace > remainingCapacity;
                var _cart_items;
                return h(SelectItemRow, {
                    key: unit.unitKey,
                    unit,
                    checked,
                    disabled,
                    onToggle: toggleItem,
                    cartItems: (_cart_items = cart === null || cart === void 0 ? void 0 : cart.items) !== null && _cart_items !== void 0 ? _cart_items : null
                });
            })
        ]),
        h('hr', {
            className: 'gift-wrapping__divider'
        }),
        h(GiftMessage, {
            title: t('gift_wrapping.steps.select_items.gift_message.label'),
            description: t('gift_wrapping.steps.select_items.gift_message.description'),
            value: state.giftboxMessage,
            placeholder: t('gift_wrapping.steps.select_items.gift_message.placeholder'),
            fieldName: 'giftbox_message',
            onChange: (v)=>setState({
                    giftboxMessage: v
                })
        })
    ]);
};
export default StepSelectItems;
